/* ============================================================================
   Humanodoro product page — gallery carousel.
   Prev/next on the main image page through the same buttons the thumbnail
   strip uses, so the big image, the active thumbnail and the alt text can
   never drift apart. The thumbnail strip keeps its own native scrolling.
   ========================================================================== */
(function () {
  'use strict';

  function initGalleryCarousel(gallery) {
    if (gallery.dataset.hdCarousel === 'true') return;
    var frame = gallery.querySelector('.hd-product-gallery__main');
    var strip = gallery.querySelector('[data-hd-product-thumbs]');
    if (!frame || !strip) return;
    gallery.dataset.hdCarousel = 'true';

    function slides() {
      return Array.prototype.filter.call(
        strip.querySelectorAll('button'),
        function (b) { return !b.hasAttribute('hidden'); }
      );
    }

    function currentIndex(list) {
      for (var i = 0; i < list.length; i += 1) {
        if (list[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function go(delta) {
      var list = slides();
      if (list.length < 2) return;
      var next = (currentIndex(list) + delta + list.length) % list.length;
      list[next].click();
      list[next].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      sync();
    }

    function makeButton(dir, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hd-gallery-nav hd-gallery-nav--' + dir;
      b.setAttribute('aria-label', label);
      b.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<path d="' + (dir === 'prev' ? 'M15 5 8 12l7 7' : 'M9 5l7 7-7 7') + '"' +
        ' fill="none" stroke="currentColor" stroke-width="2.6"' +
        ' stroke-linecap="round" stroke-linejoin="round"/></svg>';
      b.addEventListener('click', function (event) {
        event.preventDefault();
        go(dir === 'prev' ? -1 : 1);
      });
      return b;
    }

    var prev = makeButton('prev', 'Previous image');
    var next = makeButton('next', 'Next image');
    var count = document.createElement('p');
    count.className = 'hd-gallery-count';
    count.setAttribute('aria-live', 'polite');

    frame.appendChild(prev);
    frame.appendChild(next);
    frame.appendChild(count);

    function sync() {
      var list = slides();
      var many = list.length > 1;
      frame.classList.toggle('has-nav', many);
      if (many) count.textContent = (currentIndex(list) + 1) + ' / ' + list.length;
    }

    frame.setAttribute('tabindex', '0');
    frame.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); go(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); go(1); }
    });

    strip.addEventListener('click', function () { window.setTimeout(sync, 0); });

    if (window.MutationObserver) {
      new MutationObserver(function () { sync(); }).observe(strip, {
        attributes: true, subtree: true, attributeFilter: ['hidden', 'class']
      });
    }

    sync();
  }

  function boot() {
    document.querySelectorAll('.hd-product-gallery').forEach(initGalleryCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
}());
